export class Outsource_Lead{
    _id: string;
    id: string;
    
    coverletter:string;
    date:string;
    outsource:{_id:string,id:string};
    links:string;
    notes:string;
    admin_notes:string;
    channelId:{_id:string,id:string};
    leads:{
        title:string;
        ip:string;
        lastresponse:string;
        last_activedate:string;
        platform:string;
        lead_stage:{_id:string,id:string};
        lead_status:{_id:string,id:string};
        next_action:{_id:string,id:string};
        source:{_id:string,id:string};
        type:{_id:string,id:string};
   }
   is_invited:string;
   technology:{_id:string,id:string};
      
}